export { default as TripRiderAssign } from './trip-rider-assign';
